import { render } from "./uploaddoc.vue?vue&type=template&id=6d9f3b03"
import script from "./uploaddoc.vue?vue&type=script&lang=js"
export * from "./uploaddoc.vue?vue&type=script&lang=js"

import "./uploaddoc.vue?vue&type=style&index=0&id=6d9f3b03&lang=css"

import exportComponent from "D:\\work\\work\\project\\intelegent\\ips\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__